import StartSound from "../assets/sounds/Start.mp3";
import WinSound from "../assets/sounds/Win.mp3";
import CountdownSound from "../assets/sounds/Countdown1.mp3";
import CountEndSound from "../assets/sounds/Count End.mp3";
import ButtonSound from "../assets/sounds/Button.mp3";

import Lucky1 from "../assets/sounds/Multiplier/Lucky1.mp3";
import Lucky2 from "../assets/sounds/Multiplier/Lucky2.mp3";
import Lucky3 from "../assets/sounds/Multiplier/Lucky3.mp3";

const sounds = {
  start: new Audio(StartSound),
  win: new Audio(WinSound),
  lose: new Audio(CountEndSound), // Placeholder for missing Lose.mp3
  countdown: new Audio(CountdownSound),
  button: new Audio(ButtonSound),
  countend: new Audio(CountEndSound),
};

const multiplierSounds = [
  new Audio(Lucky1),
  new Audio(Lucky2),
  new Audio(Lucky3),
];

multiplierSounds.forEach((sound) => {
  sound.preload = "auto";
  sound.volume = 1;
});

let multiplierIndex = 0;


Object.values(sounds).forEach((sound) => {
  sound.preload = "auto";
  sound.volume = 1;
});

multiplierSounds.forEach((sound) => {
  sound.preload = "auto";
  sound.volume = 1;
});

sounds.countdown.loop = true;

export const playSound = (type) => {
  const sound = sounds[type];

  if (!sound) return;

  sound.pause();
  sound.currentTime = 0;

  sound.play().catch(() => {});
};

export const playLoopSound = (type) => {
  if (type === "countdown") return;
  const sound = sounds[type];

  if (!sound) return;

  if (!sound.paused) return;

  sound.loop = true;
  sound.currentTime = 0;

  sound.play().catch(() => {});
};

export const stopSound = (type) => {
  const sound = sounds[type];

  if (!sound) return;

  sound.pause();
  sound.currentTime = 0;
};

export const stopAllSounds = () => {
  Object.values(sounds).forEach((sound) => {
    sound.pause();
    sound.currentTime = 0;
  });

  multiplierSounds.forEach((sound) => {
    sound.pause();
    sound.currentTime = 0;
  });
};

export const setSoundVolume = (volume) => {
  Object.values(sounds).forEach((sound) => {
    sound.volume = volume;
  });

  multiplierSounds.forEach((sound) => {
    sound.volume = volume;
  });
};


export const playMultiplierSound = () => {
  const sound = multiplierSounds[multiplierIndex];

  sound.pause();
  sound.currentTime = 0;

  sound.play().catch(() => {});

  // 0 -> 1 -> 2 -> 0 -> 1 -> 2 ...
  multiplierIndex = (multiplierIndex + 1) % multiplierSounds.length;
};

export const playRandomMultiplierSound = () => {
  const randomIndex = Math.floor(Math.random() * multiplierSounds.length);
  playMultiplierSound(randomIndex);
};
